import React from 'react'
import classnames from 'classnames'

import { container } from './Quote.module.scss'

const Quote = ({ className, children, ...props }) => {
  return (
    <blockquote
      className={classnames(container, className)}
      {...props}
      dangerouslySetInnerHTML={{ __html: children }}
    />
  )
}

export default Quote
